import React from 'react';
import PropTypes from 'prop-types';
import { StyledLogo } from './styled';
import { Link } from 'react-router-dom';
import { paths } from '../../routes';

const Logo = ({ variant, width, height, customStyle }) => {
  return (
    <Link to={paths.home}>
      <StyledLogo variant={variant} customStyle={customStyle}>
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 192.902 80">
          <defs>
            <filter id="b" x="100.441" y="-7.5" width="66.282" height="76.538" filterUnits="userSpaceOnUse">
              <feOffset />
              <feGaussianBlur stdDeviation="2.5" result="blur" />
              <feFlood floodOpacity=".502" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
          </defs>
          <g className="icon-sky">
            <path d="M85.38 76.474c-1.1 2.616-3.8 4.136-7.427 3.292a5.27 5.27 0 01-3.376-7.09l6.586-16.373-12.238-28.527a5.311 5.311 0 013.46-7.005c3.714-.928 6.415.76 7.343 3.376l7.427 19.243 7.6-19.243c.928-2.616 3.629-4.3 7.343-3.376a5.311 5.311 0 013.461 7.005zM47.096 45.484v10.958c0 3.019-2.761 5.349-6.04 5.349-3.193 0-5.954-2.416-6.04-5.349V5.35C35.102 2.416 37.863 0 41.056 0c3.279 0 6.04 2.33 6.04 5.35V32.2l9.4-9.491a5.735 5.735 0 017.766-.691 5.378 5.378 0 01.776 7.68l-9.4 9.146 13.287 13.892a5.273 5.273 0 01-.345 7.852c-2.157 1.812-6.213 1.553-7.938-.518zM2.405 47.213a5.3 5.3 0 016.319 1.432 9.932 9.932 0 007.413 3.454c2.611 0 5.054-.421 5.054-2.443 0-1.685-1.011-2.274-3.876-3.2l-4.464-1.6c-11.793-3.959-11.71-9.519-11.71-13.142 0-5.813 6.993-11.2 15.248-11.2 5.644 0 11.457 1.769 14.153 6.487 1.432 2.527.757 4.97-1.011 5.981-2.612 1.516-5.054.926-7.5-.927a7.684 7.684 0 00-4.719-1.769c-2.527 0-4.3.842-4.3 2.359 0 1.264 1.011 2.022 3.37 2.78l5.981 2.022c9.519 3.117 10.7 9.266 10.7 11.794 0 8.34-8.761 12.3-17.017 12.3-6.318 0-13.732-2.612-15.753-8.424-.833-2.446.174-5.057 2.112-5.904z" />
          </g>
          <g className="icon-do">
            <path data-name="Path 47" d="M185.072 1.136h-1.171a2.408 2.408 0 010-1.094h3.585q.028.154.042.288a2.443 2.443 0 01.014.253 3.338 3.338 0 01-.056.554h-1.172v3.929a3.821 3.821 0 01-.617.063 3.758 3.758 0 01-.625-.063z" />
            <path data-name="Path 48" d="M188.216.056q.147-.021.319-.039a3.186 3.186 0 01.319-.017 2.914 2.914 0 01.3.017q.165.018.306.039l1 2.61 1.031-2.61c.093-.014.188-.027.284-.039a2.361 2.361 0 01.284-.017 2.693 2.693 0 01.3.017c.1.012.2.025.3.039l.238 5.009q-.112.021-.249.042a2.471 2.471 0 01-.361.021 3.229 3.229 0 01-.583-.063l-.1-2.9-.771 1.915c-.084.014-.168.026-.253.035a2.057 2.057 0 01-.232.014c-.07 0-.142 0-.217-.01a1.694 1.694 0 01-.231-.038l-.687-1.887-.077 2.876a2.682 2.682 0 01-.561.063 3.008 3.008 0 01-.568-.063z" />
            <path data-name="marker" d="M167.428 10.256a20.5 20.5 0 00-17.809 10.339 2.682 2.682 0 00-2.547.7l-7.58 7.58a2.687 2.687 0 000 3.79l7.58 7.58a2.681 2.681 0 002.547.7 20.512 20.512 0 1017.809-30.689zm0 28.718a8.205 8.205 0 118.2-8.205 8.2 8.2 0 01-8.2 8.205z" />
            <g clipPath="url(#a)" transform="translate(-583.84 -384)">
              <g transform="translate(583.84 384)" filter="url(#b)">
                <path d="M128.454 0h-15.385a5.128 5.128 0 00-5.128 5.128V56.41a5.128 5.128 0 005.128 5.128h15.385a30.769 30.769 0 000-61.538zm0 49.231h-8.205V12.308h8.205a18.4615 18.4615 0 110 36.923z" />
              </g>
            </g>
            <path d="M128.454 0h-15.385a5.128 5.128 0 00-5.128 5.128V56.41a5.128 5.128 0 005.128 5.128h15.385a30.769 30.769 0 000-61.538zm0 49.231h-8.205V12.308h8.205a18.4615 18.4615 0 110 36.923z" />
          </g>
        </svg>
      </StyledLogo>
    </Link>
  );
};

Logo.propTypes = {
  variant: PropTypes.oneOf(['white', 'purple']),
  width: PropTypes.number,
  height: PropTypes.number,
  customStyle: PropTypes.array
};

Logo.defaultProps = {
  variant: 'purple',
  width: 125,
  height: 52
};

export default React.memo(Logo);
